// hooks/Cases/useCaseSearch.ts
import { useCallback, useRef } from "react";
import { Endpoint } from "../../api/base";
import { addOriginalIndexes } from "../../components/shared/helpers/helper";
import { useCaseListContext } from "../../context/CaseListContext";

export const useCaseSearch = () => {
  const {
    searchValue,
    filters,
    page,
    setList,
    setCaseLoader,
    setLoaderState,
    setnoOfPages,
  } = useCaseListContext();

  const searchValueRef = useRef(searchValue);
  searchValueRef.current = searchValue;

  const handleSearchSubmit = useCallback(async () => {
    setCaseLoader(true);
    setLoaderState(true);

    // Build query from current state
    const searchQuery: any = {
      page_number: page,
      search_string: searchValueRef.current,
    };

    // Add filters to query
    filters.forEach((filter) => {
      searchQuery[filter.key] = filter.value;
    });

    try {
      const res = await Endpoint.searchCases(searchQuery);

      if (res.data.total_pages) {
        setnoOfPages(res.data.total_pages);
      } else if (res.data.items?.length === 0) {
        setnoOfPages(0);
      }

      const caseList = addOriginalIndexes(res.data.items);
      setList(caseList);
    } catch (err) {
      console.error("Search error:", err);
      setnoOfPages(0);
      setList([]);
    } finally {
      setCaseLoader(false);
      setLoaderState(false);
    }
  }, [page, filters, setCaseLoader, setLoaderState, setnoOfPages, setList]);

  return { handleSearchSubmit };
};
